module.exports = __webpack_public_path__ + "static/media/sr.d723048e.jpg";